'use es6';

import * as sorting from './sort';
import * as paging from './page';
export const preprocess = (spec, config) => response => {
  const sort = sorting.get(spec, config);
  const page = paging.get(spec, config);
  return page(sort(response));
};